import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import * as subscriptions from '../../Store/subscriptions'
import FloatingFeedback from '../../FloatingFeedback/FloatingFeedback'
import { connect } from 'react-redux'
import { Button } from "antd";
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'

const mapStateToProps = (state) => {
  return {
      showFeedback: state.subscriptionReducer.showFeedback,
      selectedProduct: state.subscriptionReducer.selectedProduct,
      selectedFeature: state.subscriptionReducer.selectedFeature,
  }
}

const mapDispatchToProps = (dispatch) => ({
  setShowFeedback: (show) => dispatch(subscriptions.setShowFeedback(show)),
  setSelectedProduct: (product) => dispatch(subscriptions.setSelectedProduct(product)),
  setSelectedFeature: (feature) => dispatch(subscriptions.setSelectedFeature(feature)),
});



export default function Warning({ content }) {
  return (
    <Container
      style={{
        backgroundColor: "rgba(255, 170, 41, 0.3)",
        padding: "15px",
        borderRadius: "4px",
      }}
    >

        <Row>
          <Col md={1}>
              <img
              src="/images/warningSignYellow.png"
              style={{ width: "35px", paddingRight:"10px" }}
            />
          </Col>
          <Col md={11} className="text-left">
            {content}
          </Col>
        </Row>
    </Container>
  );
}

const WarningWithFeedbackComponent = (props) => {
  const {message, title, product, feature, type} = props;
  const content = <div className="text-left" style={{paddingLeft: 45}}>
    <div>{message}</div>
    <div ><Button type="link" style={{padding: 0, marginTop: 5}} onClick={
      () => {
        props.setShowFeedback(true)
        props.setSelectedProduct(product || "")
        props.setSelectedFeature(feature || "")
        track(STATSIG.COMMON.FEEDBACK, 'open', {
            source: 'report_issue',
        })
      }
    }>Report issue</Button></div>
  </div>

  return (
    <div>
      <div
        style={{
          backgroundColor: "#F8E8D3",
          padding: "15px",
          borderRadius: "10px",
        }}
      >

          <div style={{display: "flex", alignItems: "center"}}>
            <img
            src="/images/systemFeatures/warning.svg"
            style={{ paddingRight:"10px" }}
            />
            <div className="text-left " style={{fontSize: "16px", fontWeight: 500}}>
              {title ? title : "Warning"}
            </div>
          </div>
          {content}
      </div>
      {props.showFeedback && (
        <FloatingFeedback 
          showFeedback={props.showFeedback}
          setShowFeedback={props.setShowFeedback}
          selectedProduct={props.selectedProduct}
          selectedFeature={props.selectedFeature}
          feedbackType={type === "issue" ? "issue" : "feedback"}
        />
      )}
    </div>
  );
}

export const WarningWithFeedback = connect(mapStateToProps, mapDispatchToProps)(WarningWithFeedbackComponent);